var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: {
      modalId: "modal-lv2",
      withBgClickEvent: "",
      contentClass: "overflow-y-auto content_resouce_modal",
      portal_class: "notes_resouce_portal_wrapper",
    },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "flex justify-between items-center" }, [
              _c(
                "h5",
                {
                  staticClass:
                    "font-bold text-gray-800 divide-x divide-gray-200",
                },
                [
                  _c("span", { staticClass: "pr-3" }, [
                    _vm._v("Resource notes"),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "ml-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("CrossIconNew", { staticClass: "h-5 w-5" })],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "py-5" }, [
              _vm._v(_vm._s(_vm.message || "No note was added")),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }